import React, { useState } from 'react';
import { useBreakpoint } from '../../util/Breakpoint.context';
import { vercel_base_url } from '../../util/config';
// TODO: Replace Record<string, never> type with null when code has been refactored to `useQuickView` instead of directly pulling context.
export var QuickViewContext = React.createContext({});
var QuickViewProvider = function (_a) {
    var children = _a.children;
    var currentBreakpoints = useBreakpoint();
    var _b = useState(null), activeProductId = _b[0], setActiveProductId = _b[1];
    var _c = useState(new Map()), variant = _c[0], setVariant = _c[1];
    var _d = useState(null), handle = _d[0], setHandle = _d[1];
    var _e = useState(false), containerStylesApplied = _e[0], setContainerStylesApplied = _e[1];
    var params = new URLSearchParams();
    variant.forEach(function (value, key) {
        params.append(key === 'color' ? 'variant' : key, value);
    });
    var PDPLink = handle ? "".concat(vercel_base_url).concat(handle, "?").concat(params) : null;
    return (React.createElement(QuickViewContext.Provider, { value: {
            isQuickView: true,
            activeProductId: activeProductId,
            setActiveProductId: setActiveProductId,
            variant: variant,
            setVariant: setVariant,
            setHandle: setHandle,
            PDPLink: PDPLink,
            containerStylesApplied: currentBreakpoints.medium
                ? containerStylesApplied
                : true,
            setContainerStylesApplied: setContainerStylesApplied
        } }, children));
};
/**
 * Custom hook for adding QuickView functionality to a component
 */
export var useQuickView = function () {
    var context = React.useContext(QuickViewContext);
    if (context === null) {
        throw new Error('useQuickView must be used within a QuickViewProvider');
    }
    return context;
};
export default QuickViewProvider;
